<mat-card appearance="outlined" *ngIf="showMessageInfo" class="message-info-block mb-1">
  <h3 [innerHTML]="messageInfo.titre"></h3>
  <div class="alert" [ngClass]="[alertClass, messageInfo.importance]" [innerHTML]="messageInfo.contenu"></div>
</mat-card>
